import { AbstractPmsApiService } from "./abstract.service";
import { BaladyApiSetting } from "../models";

/**
 * @class BaladyApiSettingPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<BaladyApiSetting>}
 */
export class BaladyApiSettingPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/balady-api-setting';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {BaladyApiSetting}
     * @protected
     */
    newModel(attributes, ...params) {

        return new BaladyApiSetting(attributes);
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<BaladyApiSetting>}
     */
    get(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {BaladyApiSetting} settings
     * @returns {Promise.<BaladyApiSetting>}
     */
    save(property, settings) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, settings, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * Check invoice by given number
     *
     * @param {Property} property
     * @param {string} invoiceNumber
     * @returns {Promise.<Object>}
     */
    checkInvoice(property, invoiceNumber) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url + '/check-invoice', {invoice_number: invoiceNumber}, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/balady-api-setting.service.js